<template>
    <div v-if="etiquetas.length>0" class="wpb_wrapper" style="height: 180px;position: relative;width: 100%;">
        <vue-word-cloud :words="etiquetas" :color="getColor">
            <template slot-scope="{text, weight, word}">
                <div :title="text" style="cursor: pointer;" @click="onClick(word)">
                    {{ text }}
                </div>
            </template>
        </vue-word-cloud>
    </div>
</template>

<script>
    import axios from 'axios';
    import VueWordCloud from 'vuewordcloud';
    import * as chroma from 'chroma-js';

    const WS_URL='https://admin.fundacionmarianoruizfunes.com/api/ws/criterio';
    //const WS_URL='http://fmrf2.local/api/ws/criterio';
    let headers = {
        'Content-Type': 'application/json'
    };

    export default {
        name: "NubeEtiquetas",
        components: { [VueWordCloud.name]: VueWordCloud },
        data() {
            return {
                etiquetas: [],
                maxWeight: 0,
                minWeight: 0
            }
        },
        methods: {
            leerNubeEtiquetas() {
                axios
                    .post(WS_URL, {
                        "operacion": "getNubeEtiquetas"
                    }, {"headers": headers})
                    .then(response => {
                        this.etiquetas = response.data;
                        if(this.etiquetas.length>0) {
                            this.maxWeight = Math.max(...this.etiquetas.map(o => o.weight));
                            this.minWeight = Math.min(...this.etiquetas.map(o => o.weight));
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getColor(a,index){
                let weight=this.etiquetas[index].weight;
                let porcentaje=(weight - this.minWeight) / (this.maxWeight - this.minWeight);
                // let scale=chroma.scale(['8fbbda', '1f77b4']);
                let scale=chroma.scale(['c1ac89', '997f54']);
                return scale(porcentaje).hex();
            },
            onClick(word){
                this.$emit('click', word.id);
            }
        },
        mounted() {
            this.leerNubeEtiquetas();
        }
    }
</script>
